import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import app from './app';
import chat from './chat';
import user from './user';
import consults from './consults';
import info from './info';
import prescription from './prescription';
import savedPrescription from './savedPrescription';
import symptoms from './symptoms';
import conditions from './conditions';
import filters from './filters';
import videoFeedback from './videoFeedback';
import digitisation from './digitisation';
import digitisationPincode from './digitisationPincode';
import videoSession from './videoSession';
import consultation from './consultation';
import loginError from './loginError';
import lastDigitisation from './lastDigitisation';
import fwaDigi from './fwaDigi';

// `SET_INFO` (which populates all of `info`) runs ONLY at login (loginUser saga),
// never on a plain page refresh. `user` (incl. authToken) IS persisted, so an
// already-logged-in user who refreshes stays on the dashboard WITHOUT re-running
// SET_INFO — the app then relies entirely on the persisted `info`. So everything in
// `info` that any refresh-time component reads (prescriptions.durations/dosages,
// verticals, endReasons, pubnubChannelGroup…) must stay persisted.
//
// The ONLY problem member is `sponsors` — a ~68k-item array that pushed the persisted
// blob past the ~5MB localStorage quota, silently failing the whole persist write
// (auth token included) and logging users out on refresh. It is re-fetched at login
// and is not read synchronously at construction, so it is the one field we exclude.
const infoPersistConfig = {
  key: 'info',
  storage,
  blacklist: ['sponsors'],
};

// `app` holds the login flags that must survive a refresh, but `documentsList` is a
// transient upload list (App.js resets it on mount/online) — exclude just that field.
const appPersistConfig = {
  key: 'app',
  storage,
  blacklist: ['documentsList'],
};

export default {
  app: persistReducer(appPersistConfig, app),
  chat,
  consults,
  user,
  info: persistReducer(infoPersistConfig, info),
  prescription,
  savedPrescription,
  symptoms,
  conditions,
  filters,
  videoFeedback,
  digitisation,
  digitisationPincode,
  videoSession,
  consultation,
  loginError,
  lastDigitisation,
  fwaDigi,
};
